<template>
  <div>
    <PageLoader :storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#427D2D" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #fff">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-layout wrap justify-center>
      <v-flex xs12>
        <v-layout wrap justify-start pa-5>
          <!-- Header Row -->
          <v-layout row justify-space-between align-center>
            <v-flex xs12 sm6 md6 lg6>
              <span class="heading">Anti-Venom Stock</span>
            </v-flex>
            <v-flex xs12 sm6 md6 lg6 pt-2 pt-lg-0 pt-md-0 pt-sm-0 class="text-right" v-if="!isReadOnly">
              <v-btn color="#427D2D" class="mr-2" @click="openAddStockModal()">
                <span
                  style="
                    font-size: 12px;
                    font-family: poppinssemibold;
                    color: white;
                  "
                >
                  Add Stock
                  <v-icon color="white" small class="ml-1">mdi-plus</v-icon>
                </span>
              </v-btn>
              <v-btn color="#D32F2F" @click="openReduceStockModal()">
                <span
                  style="
                    font-size: 12px;
                    font-family: poppinssemibold;
                    color: white;
                  "
                >
                  Reduce Stock
                  <v-icon color="white" small class="ml-1">mdi-minus</v-icon>
                </span>
              </v-btn>
            </v-flex>
          </v-layout>

          <!-- Stats Cards Section (using standard StatCard component matching dashboard theme) -->
          <v-flex xs12 pt-4 v-if="dashboardItems && dashboardItems.length > 0">
            <v-layout wrap justify-start>
              <v-flex
                v-for="(item, index) in dashboardItems"
                :key="'stat-' + index"
                xs12
                sm6
                md4
                lg3
                pa-2
              >
                <StatCard
                  :card="{
                    title: item.venom && item.venom.name ? item.venom.name : 'Venom',
                    value: item.stock,
                    mdiIcon: 'mdi-needle',
                    hint: 'Total bottles in stock'
                  }"
                />
              </v-flex>
            </v-layout>
          </v-flex>

          <!-- Stock Details Table Section -->
          <v-flex xs12 pt-5 v-if="historyItems && historyItems.length > 0">
            <v-card>
              <div style="overflow-y: auto; overflow-x: auto;">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left tablehead">Venom</th>
                        <th class="text-left tablehead" v-if="isReadOnly">Hospital</th>
                        <th class="text-left tablehead">Stock (Bottle)</th>
                        <th class="text-left tablehead">Updated Date</th>
                        <th class="text-left tablehead action-column" v-if="!isReadOnly">Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in historyItems" :key="index">
                        <td style="white-space: nowrap;" class="tableitems">
                          {{ item.venom && item.venom.name ? item.venom.name : '-' }}
                        </td>
                        <td style="white-space: nowrap;" class="tableitems" v-if="isReadOnly">
                          {{ item.hospital && item.hospital.name ? item.hospital.name : '-' }}
                        </td>
                        <td style="white-space: nowrap;" class="tableitems font-weight-bold" :style="{ color: item.quantityAdded < 0 ? '#C62828' : '#2E7D32' }">
                          {{ item.quantityAdded > 0 ? '+' + item.quantityAdded : item.quantityAdded }}
                        </td>
                        <td style="white-space: nowrap;" class="tableitems">
                          {{ formatDate(item.createdAt) }}
                        </td>
                        <td style="white-space: nowrap;" class="action-column" v-if="!isReadOnly">
                          <v-icon
                            small
                            color="error"
                            class="ml-4"
                            @click.stop="opendeleteDialog(item)"
                          >
                            mdi-delete
                          </v-icon>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </v-card>
          </v-flex>

          <!-- No Data message -->
          <v-flex xs12 pt-5 v-else-if="!appLoading">
            <v-layout wrap justify-center align-center>
              <v-flex xs12 class="text-center">
                <span class="nodata">No Stock Data Found !</span>
              </v-flex>
            </v-layout>
          </v-flex>

        </v-layout>
      </v-flex>

      <!-- Pagination -->
      <v-flex xs12 pb-4 v-if="pages > 0">
        <v-layout wrap justify-center>
          <v-flex xs10>
            <v-pagination
              :length="pages"
              v-model="currentPage"
              color="#427D2D"
              :total-visible="7"
              circle
            ></v-pagination>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- Add / Reduce Stock Dialog (Only accessible to Medical Officers) -->
    <v-dialog v-model="adddialog" max-width="720px" v-if="!isReadOnly">
      <v-card rounded="lg">
        <v-card-title class="d-flex align-center justify-space-between pa-4">
          <span class="heading" :style="{ color: stockAction === 'reduce' ? '#C62828' : '#2E7D32' }">
            {{ stockAction === 'reduce' ? 'REDUCE STOCK' : 'ADD STOCK' }}
          </span>
          <v-btn color="red" icon @click="adddialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text class="pa-4">
          <v-form>
            <v-layout wrap justify-start pt-2>
              <v-flex xs12>
                <v-layout
                  class="pb-3"
                  wrap
                  align-start
                  v-for="(entry, index) in stockData"
                  :key="index"
                >
                  <v-flex xs12 sm12 md12 lg6 pr-md-2>
                    <div class="d-flex align-center justify-space-between pb-1" style="min-height: 22px; line-height: 22px;">
                      <span class="tablehead" style="color:black">Anti-venom</span>
                      <span v-if="stockAction === 'reduce' && entry.venom" style="font-size:12px; color:#C62828; font-weight:600;">
                        Current stock: <strong>{{ getAvailableStock(entry.venom) }}</strong> bottles
                      </span>
                    </div>
                    <v-select
                      outlined
                      dense
                      hide-details
                      :items="getFilteredVenoms(index)"
                      v-model="entry.venom"
                      placeholder="Select Anti-venom"
                      class="text-field"
                      item-text="name"
                      item-value="_id"
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm12 md12 lg5 pl-md-2>
                    <div class="d-flex align-center justify-space-between pb-1" style="min-height: 22px; line-height: 22px;">
                      <span class="tablehead" style="color:black">
                        {{ stockAction === 'reduce' ? 'Quantity to Reduce (Bottles)' : 'Stock to Add (Bottles)' }}
                      </span>
                    </div>
                    <v-text-field
                      class="text-field"
                      :placeholder="stockAction === 'reduce' ? 'e.g. 5' : 'e.g. 10'"
                      outlined
                      dense
                      hide-details
                      type="number"
                      v-model="entry.stock"
                    ></v-text-field>
                  </v-flex>
                  <v-flex pl-lg-4 pl-sm-3 pl-md-3 pl-0 pt-6>
                    <v-btn
                      icon
                      @click="removeEntry(index)"
                      color="red"
                      small
                      v-if="stockData.length > 1"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex pt-2>
                <v-btn
                  outlined
                  :color="stockAction === 'reduce' ? '#D32F2F' : '#427D2D'"
                  @click="addEntry"
                  small
                  :disabled="isAddDisabled"
                >
                  <v-icon>mdi-plus</v-icon>Add Another Entry
                </v-btn>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>

        <v-card-actions class="py-4 px-4 justify-end headline lighten-2">
          <v-btn
            tile
            outlined
            color="#FF1313"
            light
            :ripple="false"
            depressed
            class="itemValue"
            text
            @click="adddialog = false"
          >
            <span style="color: black">Cancel</span>
          </v-btn>
          <v-btn
            tile
            :color="stockAction === 'reduce' ? '#D32F2F' : '#427D2D'"
            light
            :ripple="false"
            depressed
            class="itemValue"
            @click="itemadd()"
          >
            <span style="color: white">{{ stockAction === 'reduce' ? 'Confirm Reduce Stock' : 'Save Changes' }}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Confirmation Dialog -->
    <v-dialog v-model="deleteDialog" max-width="500" v-if="!isReadOnly">
      <v-card rounded="lg">
        <v-card-title class="heading">Confirmation</v-card-title>
        <v-card-text>Are you sure you want to delete this venom stock entry?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            tile
            outlined
            color="#FF1313"
            light
            :ripple="false"
            depressed
            @click="deleteDialog = false"
            class="itemValue"
          >
            Cancel
          </v-btn>
          <v-btn
            tile
            :color="appColor"
            light
            :ripple="false"
            depressed
            @click="deleteoperation()"
            class="itemValue"
          >
            <span style="color: #fff">Submit</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import StatCard from "@/components/Common/statCard";

export default {
  components: {
    StatCard,
  },
  data() {
    return {
      currentPage: 1,
      pages: 0,
      limit: 10,
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,

      dashboardItems: [],
      historyItems: [],

      deleteDialog: false,
      deleteid: "",
      adddialog: false,
      stockAction: "add",

      venomArray: [],
      stockData: [{ venom: "", stock: "" }],
    };
  },
  mounted() {
    this.getDashboard();
    this.getHistory();
    this.getVenom();
  },
  watch: {
    currentPage() {
      this.getHistory();
    },
  },
  computed: {
    isReadOnly() {
      var storeRole = (this.$store.state && this.$store.state.userRole ? this.$store.state.userRole : "");
      var storeType = (this.$store.state && this.$store.state.userType ? this.$store.state.userType : "");
      var localRole = localStorage.getItem("role") || "";
      var localType = localStorage.getItem("type") || "";
      var localUserRole = localStorage.getItem("userRole") || "";
      var routePath = (this.$route.path || "");

      var combined = `${storeRole} ${storeType} ${localRole} ${localType} ${localUserRole} ${routePath}`.toLowerCase();

      // Read-only roles: DMO / District Medical Officer, State Level Officers, District Emergency Officer, Disaster Management Officer, Admin
      var isReadOnlyRole = (
        combined.includes("district medical officer") ||
        combined.includes("districtmedicalofficer") ||
        combined.includes("dmo") ||
        combined.includes("districtmedical") ||
        combined.includes("state") ||
        combined.includes("emergency officer") ||
        combined.includes("disaster") ||
        combined.includes("admin")
      );

      if (isReadOnlyRole) {
        return true;
      }

      // Only hospital-level MedicalOfficer accounts on /medicalOfficers have write/add stock access
      var isHospitalMedicalOfficer = (
        routePath.startsWith("/medicalOfficers") &&
        !combined.includes("district medical officer") &&
        !combined.includes("districtmedicalofficer") &&
        !combined.includes("dmo")
      );

      return !isHospitalMedicalOfficer;
    },
    isMedicalOfficer() {
      return !this.isReadOnly;
    },
    isAddDisabled() {
      const selectedVenoms = this.stockData
        .map((entry) => entry.venom)
        .filter((venom) => venom !== null && venom !== "");
      return selectedVenoms.length >= this.venomArray.length;
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return "-";
      const [year, month, day] = date.slice(0, 10).split("-");
      return `${day}-${month}-${year}`;
    },

    getFilteredVenoms(index) {
      const selectedVenoms = this.stockData
        .map((entry) => entry.venom)
        .filter((venom) => venom !== null && venom !== "");
      return this.venomArray.filter(
        (venom) =>
          !selectedVenoms.includes(venom._id) ||
          venom._id === this.stockData[index].venom
      );
    },

    addEntry() {
      this.stockData.push({ venom: "", stock: "" });
    },

    removeEntry(index) {
      this.stockData.splice(index, 1);
    },

    getDashboard() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/get/stock/dashboard",
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.dashboardItems = response.data.data;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    getHistory() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/get/stock/history/by/hospital",
        headers: { "x-auth-token": localStorage.getItem("token") },
        params: { limit: this.limit, page: this.currentPage },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.historyItems = response.data.data;
            this.pages = Math.ceil(response.data.totalLength / this.limit);
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    getVenom() {
      axios({
        method: "GET",
        url: "/list/venoms",
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
        .then((response) => {
          if (response.data.status) {
            this.venomArray = response.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    openAddStockModal() {
      if (this.isReadOnly) return;
      this.stockAction = "add";
      this.stockData = [{ venom: "", stock: "" }];
      this.adddialog = true;
    },

    openReduceStockModal() {
      if (this.isReadOnly) return;
      this.stockAction = "reduce";
      this.stockData = [{ venom: "", stock: "" }];
      this.adddialog = true;
    },

    getAvailableStock(venomId) {
      if (!venomId) return 0;
      const found = this.dashboardItems.find(
        (item) => item.venom && item.venom._id === venomId
      );
      return found ? found.stock : 0;
    },

    itemadd() {
      if (this.isReadOnly) return;
      for (let i = 0; i < this.stockData.length; i++) {
        const entry = this.stockData[i];
        if (!entry.venom || entry.venom.length === 0) {
          this.msg = `Please select anti-venom for entry ${i + 1}`;
          this.showSnackBar = true;
          return;
        }
        if (!entry.stock || isNaN(entry.stock) || Number(entry.stock) <= 0) {
          this.msg = `Please provide a valid stock quantity for entry ${i + 1}`;
          this.showSnackBar = true;
          return;
        }
        if (this.stockAction === 'reduce') {
          const avail = this.getAvailableStock(entry.venom);
          if (Number(entry.stock) > avail) {
            this.msg = `Cannot reduce stock by ${entry.stock}. Current available stock is ${avail} bottles.`;
            this.showSnackBar = true;
            return;
          }
        }
      }

      this.appLoading = true;
      axios({
        method: "POST",
        url: "/update/venom/stock",
        headers: { "x-auth-token": localStorage.getItem("token") },
        data: {
          stockAction: this.stockAction,
          stockData: this.stockData.map((entry) => ({
            venom: entry.venom,
            stock: entry.stock,
            action: this.stockAction
          })),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.adddialog = false;
            this.stockData = [{ venom: "", stock: "" }];
            this.getDashboard();
            this.getHistory();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    opendeleteDialog(item) {
      if (this.isReadOnly) return;
      this.deleteid = item._id;
      this.deleteDialog = true;
    },

    deleteoperation() {
      if (this.isReadOnly) return;
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/delete/stock/entry",
        headers: { "x-auth-token": localStorage.getItem("token") },
        data: { id: this.deleteid },
      })
        .then((response) => {
          this.deleteDialog = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.getDashboard();
            this.getHistory();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>

<style>
.heading {
  font-family: poppinsregular;
  font-size: 20px;
  font-weight: 900;
}

.subheading {
  font-family: poppinsregular;
  font-size: 15px;
  font-weight: 500;
}
</style>